import './App.scss';
import Feed from './components/Feed';
import NavBar from './components/NavBar'
import Cursor from './utils/Cursor';
import BottomMenu from './components/BottomMenu'
import {BrowserRouter} from 'react-router-dom'
import Menu from './components/Menu';
import { useState } from 'react';
import Messanger from './components/Messanger';

function App() {

  const [menuDisplay, setMenu] = useState(false)

  return (
    <div className="App">
      <BrowserRouter>
          <Cursor />
          <NavBar display={menuDisplay} setMenu={setMenu} />
          <Feed />
          <BottomMenu />
          <Menu display={menuDisplay} setMenu={setMenu} />
          <Messanger />
      </BrowserRouter>
    </div>
  );
}

export default App;
